import { createFileRoute } from "@tanstack/react-router"

import { query } from "@/api/query"
import { routeGuard } from "@/lib/routing/beforeLoad"

export const Route = createFileRoute("/_authlayout/_sidebar/plan-usage/")({
  beforeLoad: async ({ context }) => {
    await routeGuard(context)
  },
  loader: ({ context: { queryClient, spaceStorage } }) => {
    const space = spaceStorage.getSpace()
    queryClient.query({ ...query.space.members(space), staleTime: "static" })
  },
  head: () => ({
    meta: [
      {
        title: "Plan Usage | Arduino Cloud"
      }
    ]
  })
})
